import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { elementToPdf } from "@/lib/pdf";
import ReceiptDocument from "@/components/ReceiptDocument";
import { Button } from "@/components/ui/button";
import { Download, Printer } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicReceipt() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [s, setS] = useState({});
  const [loyalty, setLoyalty] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const docRef = useRef(null);

  useEffect(() => {
    axios.get(`${API}/public/receipt/${id}`)
      .then((r) => { setOrder(r.data.order); setS(r.data.settings || {}); setLoyalty(r.data.loyalty || null); })
      .catch(() => setNotFound(true));
  }, [id]);

  if (notFound) return <div className="min-h-screen grid place-items-center text-slate-400">Reçu introuvable</div>;
  if (!order) return <div className="min-h-screen grid place-items-center text-slate-400">Chargement...</div>;
  const cur = s.currency || "KMF";

  return (
    <div className="min-h-screen bg-slate-100 py-8 px-4">
      <div className="no-print flex justify-center gap-2 mb-5">
        <Button variant="outline" onClick={() => window.print()}><Printer size={16} className="mr-1.5" /> Imprimer</Button>
        <Button className="bg-sky-600 hover:bg-sky-700" onClick={() => docRef.current && elementToPdf(docRef.current, `recu-${order.order_number}.pdf`)}><Download size={16} className="mr-1.5" /> Télécharger PDF</Button>
      </div>
      <div className="print-area" ref={docRef}>
        <ReceiptDocument o={order} s={s} cur={cur} view="a4" loyalty={loyalty} />
      </div>
    </div>
  );
}
